export const logout = (history) => {
   window.localStorage.removeItem("uid")
   history('/')
};